<template>
  <v-form v-model="valid" ref="mainForm">
    <opq-case code="declaration1" v-model="sasPermisPsychotherapeute.attestation1" :live="liveSasPsychotherapeute(4628)"></opq-case>
    <opq-case code="declaration2" v-model="sasPermisPsychotherapeute.attestation2" :live="liveSasPsychotherapeute(4629)"></opq-case>
    <opq-case code="declaration3" v-model="sasPermisPsychotherapeute.attestation3" :live="liveSasPsychotherapeute(4630)"></opq-case>
    <opq-case code="declaration4" v-model="sasPermisPsychotherapeute.attestation4" :live="liveSasPsychotherapeute(4631)"></opq-case>
  </v-form>
</template>

<script>
import FormSimple from "@/mixins/FormSimple"
export default {
  mixins: [FormSimple],
  props: {
    sas: { type: Object }
  },

  computed: {
    sasPermisPsychotherapeute() {
      return this.sas.sasPermisPsychotherapeute
    }
  },

  methods: {
    liveSasPsychotherapeute(cle) {
      return { endpoint: "sas-permis-psychotherapeute", cle: cle, fileId: this.sasPermisPsychotherapeute.id }
    }
  }
}
</script>

<style>
</style>